import { cn } from '@/app/utils/style'

type SeparatorSectionBlock = {
  _type: 'separatorSection'
  _key?: string
  mode?: string
}

type SeparatorProps = {
  block: SeparatorSectionBlock
  index: number
  pageId?: string
  pageType?: string
}

export default function SeparatorSection({ block }: SeparatorProps) {
  const mode = block.mode || 'greenToWhite'
  const isGreenToWhite = mode === 'greenToWhite'

  const getColor = (row: number, col: number) => {
    const isEven = (row + col) % 2 === 0
    if (isGreenToWhite) {
      return isEven ? 'bg-green-700' : 'bg-white-default'
    } else {
      return isEven ? 'bg-white-default' : 'bg-green-700'
    }
  }

  return (
    <div className="w-full">
      {/* Mobile: 3 columns × 4 rows */}
      <div className="grid grid-cols-3 md:hidden">
        {Array.from({ length: 12 }).map((_, index) => {
          const row = Math.floor(index / 3)
          const col = index % 3
          return (
            <div key={index} className={cn('h-[32px]', getColor(row, col))} aria-hidden="true" />
          )
        })}
      </div>

      {/* Tablet: 5 columns × 4 rows */}
      <div className="hidden md:grid lg:hidden grid-cols-5">
        {Array.from({ length: 20 }).map((_, index) => {
          const row = Math.floor(index / 5)
          const col = index % 5
          return (
            <div key={index} className={cn('h-[32px]', getColor(row, col))} aria-hidden="true" />
          )
        })}
      </div>

      {/* Desktop: 7 columns × 4 rows */}
      <div className="hidden lg:grid grid-cols-7">
        {Array.from({ length: 28 }).map((_, index) => {
          const row = Math.floor(index / 7)
          const col = index % 7
          return (
            <div key={index} className={cn('h-[32px]', getColor(row, col))} aria-hidden="true" />
          )
        })}
      </div>
    </div>
  )
}
